import ContestForm from '../../components/ContestForm';
import AgeGroupLabel from '../../components/AgeGroupLabel';
import TableEditor from '../../components/TableEditor';
import { Label, Table } from '../../components';
import { createOrmActions, editorPropTypes } from '../../components/common';

import React from 'react';
import PropTypes from 'prop-types';
import { pick, sortBy } from 'lodash';

const ContestsEditorHeader = ({ children }) => (
  <Table.Row>
    <Table.HeaderCell>Age group</Table.HeaderCell>
    <Table.HeaderCell>Bodyweight category</Table.HeaderCell>
    <Table.HeaderCell>Title</Table.HeaderCell>
    <Table.HeaderCell>Minimum entry total</Table.HeaderCell>
    {children}
  </Table.Row>
);

const ContestsEditorRow = ({ row, children }) => (
  <Table.Row>
    <Table.Cell>
      <AgeGroupLabel ageGroup={row.ageGroup} />
    </Table.Cell>
    <Table.Cell>
      {row.bodyweightCategory && <Label>{row.bodyweightCategory.title}</Label>}
    </Table.Cell>
    <Table.Cell>{row.title}</Table.Cell>
    <Table.Cell>{row.entryTotalMinimum || ''}</Table.Cell>
    {children}
  </Table.Row>
);

const ContestsEditor = ({ id, contests, meta, actions }) => {
  const defaultValues = {
    ageGroup: '',
    bodyweightCategory: '',
    title: '',
    entryTotalMinimum: '',
  };

  const rows = sortBy(contests, 'order').map(contest => ({
    ...contest,
    key: contest.primaryKey,
    description: `contest ${contest.title}`,
    currentValues: {
      ageGroup: contest.ageGroup.primaryKey,
      bodyweightCategory: contest.bodyweightCategory.primaryKey,
      ...pick(contest, 'order', 'title', 'entryTotalMinimum'),
    },
  }));

  return (
    <TableEditor
      id={id}
      Form={ContestForm}
      Header={ContestsEditorHeader}
      Row={ContestsEditorRow}
      rows={rows}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
    />
  );
};

ContestsEditor.propTypes = {
  ...editorPropTypes,
  contests: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ContestsEditor;



// WEBPACK FOOTER //
// ./src/pages/Setup/ContestsEditor.js